import React, { useState, useEffect, useRef, useMemo } from 'react';
import Select from 'react-select'
import { Modal, Button, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { ReactComponent as EditIcon } from "../../../assets/images/icon_svg/edit.svg";
import { ReactComponent as MailIcon } from "../../../assets/images/slotplanning/mail_icon.svg";
import { ReactComponent as ArchiveIcon } from "../../../assets/images/slotplanning/archive_icon.svg";
import { GETDESTINATION } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';

import records from '../../../assets/images/recovery_dahboard/records.svg';
import info from '../../../assets/images/recovery_dahboard/info.svg';
import critical from '../../../assets/images/recovery_dahboard/star.svg';
import newrecords from '../../../assets/images/recovery_dahboard/record_new.svg';

import { useDispatch, useSelector } from "react-redux";
import { useGetComplianceListQuery, useGetOverviewQuery, useGetStationSettingsQuery, useToggleOverviewStatusMutation, useV2DropdownListQuery } from '../../../redux/services/SRC.js';
import TableTabs from '../../../Components/common/TableGrid/TableTabs.js';
import TableFilters from '../../../Components/common/TableGrid/TableFilters.js';
import TableGrid from "../../../Components/common/TableGrid";
import { onChangeFilters, onTabChange, clearSelectedRowsData } from "../../../redux/features/table/tableSlice";
import { CallApi, CommonModal } from '../../../Components/common/CommonFunctions.js';
import CommonCard from '../../../Components/common/CommonCard.js';

const NonCompliance = ({ dropData, reloadGrid, onNav, onEdit }) => {

    const isMounted = useRef(false);
    const history = useHistory();
    const dispatch = useDispatch();

    const [preFilter, setPreFilter] = useState(false);
    const [regionData, setRegionData] = useState();
    const [filterData, setFilterData] = useState();
    const [errorData, setErrorData] = useState();
    const [updateModal, setUpdateModal] = useState(false)
    const [resolveCode, setResolveCode] = useState([])
    const [stnList, setStnList] = useState([])
    const [modalData, setModalData] = useState({});
    const [getDestination, setGetDestination] = useState([]);

    const { data: mdrop } = useV2DropdownListQuery();
    useEffect(() => {
        if (mdrop?.response_data) {
            setResolveCode(mdrop?.response_data?.recovery_phase_to_close);
        }
    }, [mdrop]);

    const { data: stnData } = useGetStationSettingsQuery();
    useEffect(() => {
        if (stnData?.response_data) {
            const transformedData = stnData?.response_data?.map(item => ({
                value: item.port_code,
                label: item.port_code,
                address: item.address,
                station_id: item.station_id
            }));
            setStnList(transformedData);
        }
    }, [stnData]);

    const errorStation = [{ label: 'Unknown', value: 'unknown' }, ...stnList]

    const fetchRegionDropdown = async () => {
        CallApi({
            endPoint: `setting/region-dropdown`,
            method: 'get',
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                setRegionData(innerData);
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const fetchUser = async () => {
        CallApi({
            endPoint: 'v2/service-recovery/assign-user-list',
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    setFilterData((prev) => ({ ...prev, assigned_users: innerData }));
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const fetchDestination = async () => {
        CallApi({
            endPoint: GETDESTINATION,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                 const transformedData = innerData ? innerData.map(item => ({
                    value: item.port_code,
                    label: item.port_code,
                })) : [];
                setGetDestination(transformedData);
            },
            onError: (msg) => console.error(msg)
        });
    };
    const fetchDropDownList = async () => {
        CallApi({
            endPoint: "v2/non-compliance/dropdown-list",
            onSuccess: (res) => {
                const innerData = res.data.response_data.compliance_type_of_error;
                 const transformedData = innerData ? innerData.map(item => ({
                    value: item.value,
                    label: item.label,
                })) : [];
                setErrorData(transformedData);
            },
            onError: (msg) => console.error(msg)
        });
    };

    useEffect(() => {
        if (isMounted.current) return;
        isMounted.current = true;

        fetchUser();
        fetchDestination();
        fetchRegionDropdown();
        fetchDropDownList();
        dispatch(onTabChange({ key: 'recovery_type', value: "Active" }));

        // Defer preFilter dispatch until AFTER all child mount effects have run
        setTimeout(() => {
            try {
                const preFilterStr = localStorage.getItem('PreFilter');
                if (preFilterStr) {
                    const preFilter = JSON.parse(preFilterStr);
                    if (preFilter && Object.keys(preFilter).length > 0) {
                        dispatch(onChangeFilters(preFilter));
                        if (dropData) setPreFilter(true);
                    }
                }
            } catch (e) {
                localStorage.removeItem('PreFilter');
            }
        }, 0);

    }, []);

    const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

    const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return;
            }
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value); // [187,186]
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };

    const queryParams = useMemo(() => {
        const filterParams = buildFilterParams(filters);

        const params = {
            ...filterParams,
            pagenum: pageDetails.pagenum,
            pagesize: pageDetails.pagesize,
        };

        if (sortby?.sortdatafield) {
            params.sortdatafield = sortby.sortdatafield;
            params.sortorder = sortby.sortorder;
        }
        return params;
    }, [filters, pageDetails, sortby]);

    const { data: myData, isFetching, refetch } = useGetComplianceListQuery(queryParams, {
        skip: pageDetails.pagesize === 0,
        refetchOnMountOrArgChange: true,
    });

    const filtersConfig = [
        {
            type: "input",
            field: "reference_value",
            placeholder: "Search Reference",
            // format: "mawb",
        },
        {
            type: "multiselect", field: "station", placeholder: "Station",
            options: getDestination?.map((item) => ({
                label: item.label,
                value: item.value,
            })) || [],
        },
        {
            type: "multiselect", field: "region_id", placeholder: "Region",
            options: regionData?.map((item) => ({
                label: item.label,
                value: item.value,
            })) || [],
        },
        {
            type: "multiselect", field: "type_of_error", placeholder: "Type of Error",
            options: errorData?.map((item) => ({
                label: item.label,
                value: item.value,
            })) || [],
        },

    ];
    useEffect(() => {
        if (reloadGrid) {
            refetch();
        }
    }, [reloadGrid]);

    const columns = [
        {
            label: "", field: "actions", enableSearch: false, cls: "tw-3",
            renderCell: (row) => (
                <div className="tb_grid_actions">
                    <EditIcon className="row_view" style={{ cursor: "pointer" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            onEdit(row.id);
                        }} />
                </div>
            ),
        },
        { label: "Reference", field: "reference_value", enableSearch: true, cls: "tw-10" },
        { label: "Station", field: "station", enableSearch: true, cls: "tw-5" },
        { label: "Region", field: "region", enableSearch: true, cls: "tw-5" },
        { label: "Recorded Date", field: "created_date", enableSearch: true, cls: "tw-7" },
        { label: "Flight No.", field: "flight_no", enableSearch: true, cls: "tw-5" },
        { label: "Flight Date", field: "flight_date", enableSearch: true, cls: "tw-5" },
        { label: "Type of Error", field: "type_of_error_name", enableSearch: true, cls: "tw-8" },
        { label: "Details of Non-Compliance", field: "details_non_compliance", enableSearch: true, cls: "tw-10" },
        { label: "Product Code", field: "product_code_name", enableSearch: true, cls: "tw-5" },
        {
            label: "SHC",
            field: "shc_id",
            enableSearch: true,
            renderCell: (row) => (
            <div>
            {Array.isArray(row.shc_id) && row.shc_id.length > 0
            ? row.shc_id.join(", ")
            : "-"}
            </div>
            ),
        },
    ];

    const transformedRows = useMemo(() => {
        return (
            myData?.Rows?.map((item) => {
                let timeslot = "";
                if (item?.slot_start_time && item?.slot_end_time) {
                    const [, startTimeFull] = item.slot_start_time.split(" ");
                    const [, endTimeFull] = item.slot_end_time.split(" ");
                    const startTime = startTimeFull.slice(0, 5);
                    const endTime = endTimeFull.slice(0, 5);
                    timeslot = `${startTime} - ${endTime}`;
                }
                return {
                    ...item,
                    planned_date_time: item.planned_date_time
                        ? item.planned_date_time.slice(0, 16)
                        : "",
                    timeslot,
                };
            }) || []
        );
    }, [myData]);
    const iconMap = { records, info, critical, newrecords };

    const [toggleOverviewStatus] = useToggleOverviewStatusMutation();
    const handleArchive = async (rows) => {
        try {
            const ids = rows.map((r) => r.service_recovery_id);
            const res = await toggleOverviewStatus({ service_recovery_ids: ids, action: tab?.value === "Active" ? "R" : "A" }).unwrap();
            if (res?.response_code == 200) {
                toast.success(res?.response_msg);
                refetch();
                dispatch(clearSelectedRowsData(true));
            } else {
                toast.error(res?.response_msg);
            }
        } catch (err) {
            toast.error("Updation failed");
        }
    };

    const closeCase = (rows) => {
        const ids = rows.map((r) => r.service_recovery_id);
        setModalData({ service_recovery_id: ids })
        setUpdateModal(true);
    }

    const updateModalClose = () => {
        setUpdateModal(false);
    }

    const bulkActions = tab?.value == "Active"
        ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }, { label: "Close Case (s)", action: closeCase, icon: ArchiveIcon }]
        : tab?.value == "Archived"
            ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }, { label: "Close Case (s)", action: closeCase, icon: ArchiveIcon }]
            : [];

    const cardBtnClick = (name) => {
        let cardFilter = {}
        if (name === 'Action Required') {
            cardFilter = { action: [22] }
        } else if (name === 'Critical Records') {
            cardFilter = { priority: [222] }
        } else if (name === 'New Records') {
            cardFilter = { phase: [214] }
        }
        dispatch(onChangeFilters(cardFilter));
    }

    const closeRecovery = () => {
        CallApi({
            endPoint: 'v2/service-recovery/close-recovery',
            payload: modalData,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg);
                    refetch();
                    updateModalClose()
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => console.error(msg)
        });
    }

    return (
        <>
            <div className="main-content">
                {/* {cards?.length ?
                    <div className="card-bx">
                        {cards?.map((item, index) => (
                            <CommonCard key={index} icon={iconMap[item.icon]} title={item.title} value={item.value} btn={item.btn} btnClick={cardBtnClick} />
                        ))}
                    </div>
                    : <></>
                } */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <TableFilters filtersConfig={filtersConfig} pref={preFilter} />
                    {/* <TableTabs tabs={tabsConfig} /> */}
                </div>
                <div>
                    <TableGrid
                        columns={columns}
                        rows={transformedRows}
                        checkboxSelection={true}
                        totalRecords={myData?.TotalRows || 0}
                        loading={isFetching}
                        rowKey="service_recovery_id"
                        bulkActions={bulkActions}
                    />
                </div>
            </div>

            <CommonModal
                show={updateModal}
                onHide={updateModalClose}
                title=''
                subTitle=''
                className={`modal_bgw primary_modal modal_width_551`}
                footer={
                    <div className='d-flex w-100 justify-content-between'>
                        <Button variant="secondary" onClick={updateModalClose}> Cancel </Button>
                        <Button variant="primary" className="ms-auto" onClick={closeRecovery}> Confirm Closure </Button>
                    </div>
                }
            >
                <div>
                    <Form.Group className='mb-2'>
                        <Form.Label>Resolving Code (Options based on Irregularity Type) <span className='red'>*</span></Form.Label>
                        <Select
                            options={resolveCode}
                            value={resolveCode?.find(option => option.value === modalData.resolving_code) || ''}
                            onChange={(selected) => {
                                setModalData(prevFormData => ({ ...prevFormData, resolving_code: selected.value }));
                            }}
                            labelledBy="Select "
                            placeholder="Resolving Code"
                        />
                    </Form.Group>
                    {modalData?.resolving_code === 263 &&
                        <Form.Group className='mb-2'>
                            <Form.Label>Custom Resolving Code <span className='red'>*</span></Form.Label>
                            <Form.Control
                                type="text"
                                onChange={(e) => setModalData(prev => ({ ...prev, custom_resolving_code: e.target.value }))}
                                name='custom_resolving_code'
                                value={modalData?.custom_resolving_code || ''}
                                placeholder="Custom Resolving Code"
                            />
                        </Form.Group>
                    }
                    <Form.Group className='mb-2'>
                        <Form.Label>Error Station <span className='red'>*</span></Form.Label>
                        <Select
                            options={errorStation}
                            value={errorStation.find(option => option.value === modalData.error_station) || ''}
                            onChange={(selected) => {
                                setModalData(prevFormData => ({ ...prevFormData, error_station: selected.value }));
                            }}
                            labelledBy="Select "
                            placeholder="Error Station"
                        />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Closure Remark {modalData?.error_station === 'unknown' && <span className='red'>*</span>}</Form.Label>
                        <Form.Control
                            as="textarea"
                            name='closure_remarks'
                            aria-label="With textarea"
                            type="text"
                            value={modalData?.closure_remarks || ''}
                            onChange={(e) => setModalData(prev => ({ ...prev, closure_remarks: e.target.value }))}
                            placeholder="Write a remark"
                            style={{ resize: 'none', height: '142px' }}
                        />
                    </Form.Group>
                </div>
            </CommonModal>
        </>
    )
}

export default NonCompliance